export default "__VITE_ASSET__I_6kb_Q7__"